import Cookies from 'js-cookie'

const TokenKey = 'Token-Key'

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token, {expires: 0.1})
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

const SessionIdKey = 'SessionId-Key'

export function getSessionId () {
  return Cookies.get(SessionIdKey)
}

export function setSessionId (sessionId) {
  return Cookies.set(SessionIdKey, sessionId, {expires: 0.1})
}

export function removeSessionId () {
  return Cookies.remove(SessionIdKey)
}

const SignatureKey = 'Signature-Key'

export function getSignature () {
  return Cookies.get(SignatureKey)
}

export function setSignature (signature) {
  return Cookies.set(SignatureKey, signature, {expires: 0.1})
}

export function removeSignature () {
  return Cookies.remove(SignatureKey)
}

const LoginNameKey = 'LoginName-Key'

export function getLoginName () {
  return Cookies.get(LoginNameKey)
}

export function setLoginName (loginName) {
  return Cookies.set(LoginNameKey, loginName, {expires: 0.1})
}

export function removeLoginName () {
  return Cookies.remove(LoginNameKey)
}

const LoginLoginUserNoKey = 'LoginUserNo-Key'

export function getLoginUserNo () {
  return Cookies.get(LoginLoginUserNoKey)//87672
}

export function setLoginUserNo (userNo) {
  return Cookies.set(LoginLoginUserNoKey, userNo, {expires: 0.1})
}

export function removeLoginUserNo () {
  return Cookies.remove(LoginLoginUserNoKey)
}

const LoginPwdKey = 'LoginPwd-Key'

export function getLoginPwd () {
  return Cookies.get(LoginPwdKey)
}

export function setLoginPwd (loginPwd) {
  return Cookies.set(LoginPwdKey, loginPwd, {expires: 0.1})
}

export function removeLoginPwd () {
  return Cookies.remove(LoginPwdKey)
}
const LogincompanyidKey = 'Logincompanyid-Key'
export function setLoginCompanyid (loginCompanyid) {
  return Cookies.set(LogincompanyidKey, loginCompanyid, {expires: 0.1})
}

export function removeLoginCompanyid () {
  return Cookies.remove(LogincompanyidKey)
}
export function getLoginCompanyid () {
  return Cookies.get(LogincompanyidKey)
}


const redirectUrlKey = 'redirectUrl-Key'

export function getRedirectUrl () {
  return Cookies.get(redirectUrlKey)//87672
}

export function setRedirectUrl (url) {
  return Cookies.set(redirectUrlKey, url, {expires: 0.1})
}

export function removeRedirectUrl () {
  return Cookies.remove(redirectUrlKey)
}

const signPackageKey = 'signPackage-Key'

export function getSignPackageKey () {
  return Cookies.get(signPackageKey)
}

export function setSignPackageKey (data) {
  return Cookies.set(signPackageKey, data, {expires: 0.1})
}

export function removeSignPackageKey () {
  return Cookies.remove(signPackageKey)
}

const memberKey = 'member-Key'

export function getMemberKey () {
  return Cookies.get(memberKey)
}

export function setMemberKey (data) {
  return Cookies.set(memberKey, data, {expires: 0.1})
}

export function removeMemberKey () {
  return Cookies.remove(memberKey)
}

//判断浏览器是否是微信浏览器
function checkIsWechatBrowser () {
  return (
    navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
    "micromessenger"
  );
};

//微信浏览器中打开H5隐藏顶部导航方法
export function hidePageNavInWechatBrowser () {
  //#ifdef H5
  if (checkIsWechatBrowser()) {
    let pageNav = document.getElementsByTagName("uni-page-head");
    document.title=""
    if (pageNav && pageNav[0]) {
      pageNav[0].style.display = "none";
    }
  }
  //#endif
};


// WEBPACK FOOTER //
// ./src/utils/auth.js